import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import {
  RemoteLevelMenu,
  SideBar,
  TimeZoneAutocomplete,
  TimeZonesInfoList,
  TimeZoneSummaryHeading,
  WorldMapVisualization,
} from 'components';
import { useScreenWidth } from 'hooks';
import { calculateTimeDifference } from 'services';

import { useTimeZoneCrossOverCalculatorState } from './useTimeZoneCrossOverCalculatorState';

const TZ_AUTOCOMPLETE_WRAPPER_ID = 'tz-autocomplete';
const MAP_WRAPPER_ID = 'map-wrapper';

export const TimeZoneCrossOverCalculator = () => {
  const { isMobile } = useScreenWidth();
  const {
    autocompleteOptions,
    // overlappedTimeZonesWithCountries,
    matchedTzNamesWithOffset,
    timeZonesWithCountries,
    selectedTz,
    remoteLevel,
    changeSelectedTz,
    changeSelectedRemoteLevel,
    onClearResults,
    selectDefaultTz,
    initialTz,
  } = useTimeZoneCrossOverCalculatorState();

  return (
    <>
      <Box
        display="flex"
        flexWrap="wrap"
        flexDirection={isMobile ? 'column' : 'row'}
      >
        <SideBar>
          <TimeZoneAutocomplete
            wrapperId={TZ_AUTOCOMPLETE_WRAPPER_ID}
            selectedTz={selectedTz}
            changeSelectedTz={changeSelectedTz}
            autocompleteOptions={autocompleteOptions}
            error={
              !selectedTz && remoteLevel
                ? 'Please select preferred time zone'
                : null
            }
          />
          <Button
            onClick={selectDefaultTz}
            size="small"
            variant="contained"
            disabled={initialTz?.id === selectedTz?.id}
            sx={{ mb: 5 }}
          >
            Reset
          </Button>
          <RemoteLevelMenu
            changeSelectedRemoteLevel={(remoteLevel) => {
              changeSelectedRemoteLevel(remoteLevel);

              if (!selectedTz) {
                document
                  .getElementById(TZ_AUTOCOMPLETE_WRAPPER_ID)
                  ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
              } else {
                document.getElementById(MAP_WRAPPER_ID)?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                });
              }
            }}
            remoteLevel={remoteLevel}
          />

          <Box
            py={12}
            mt="auto"
            position="sticky"
            bottom={0}
            sx={{
              backgroundColor: 'grey.A100',
            }}
          >
            <Button variant="outlined" onClick={onClearResults} fullWidth>
              Clear results
            </Button>
          </Box>
        </SideBar>

        <Box
          px={8}
          flex={1}
          sx={{
            scrollMarginTop: '92px',
            minWidth: '0px',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: (theme) =>
              `inset 0px -1px 0px 0px ${theme.palette.borderColor.main}`,
          }}
        >
          <Box mx={8} minHeight="48px">
            <TimeZoneSummaryHeading
              selectedTz={selectedTz}
              hasResults={!!selectedTz && !!remoteLevel}
            />
          </Box>

          <Box
            sx={{
              my: 'auto',
            }}
          >
            <WorldMapVisualization
              sourceTimeZoneName={selectedTz?.id || null}
              minutesOffset={remoteLevel?.allowedOverlap ?? null}
              changeSelectedTz={changeSelectedTz}
              matchedTzNamesWithOffset={matchedTzNamesWithOffset}
              mapWrapperId={MAP_WRAPPER_ID}
              workingDayLengthInMinutes={
                remoteLevel
                  ? calculateTimeDifference({
                      workingDayStartAmPm: remoteLevel.workingDayStartAmPm,
                      workingDayEndAmPm: remoteLevel.workingDayEndAmPm,
                    })
                  : null
              }
            />
          </Box>

          {/* <Box mb={20}>
          <UsefulLinks selectedRemoteLevel={remoteLevel} />
        </Box> */}
        </Box>
        <Box my={20} px={10} width="100%">
          <TimeZonesInfoList timeZonesWithCountries={timeZonesWithCountries} />
        </Box>
      </Box>
    </>
  );
};
